import React, { useEffect, useState } from 'react';
import { format, differenceInMinutes, parse, parseISO } from 'date-fns';
import axios from 'axios';
import { base_url } from '../../../utils/AxiosConfig';
import { toast } from 'react-toastify';


const AttendancePopup = ({ popUpData, date, setDate }) => {

// Create a date object from the string
const convertedDate = new Date(date);

// Get the current time (hours, minutes, seconds) from a new Date()
const currentTime = new Date();

const [postData,setPostData] = useState([])

// Set the time of convertedDate to the current time
convertedDate.setHours(currentTime.getHours());
convertedDate.setMinutes(currentTime.getMinutes());
convertedDate.setSeconds(currentTime.getSeconds());

console.log('Converted Date with Current Time:', convertedDate);

const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
let companyCode = null

if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
}

const cmpCode = companyCode;

const [rows, setRows] = useState([
  { reqtime: null, type: 'IN' }, // Initialize with null
]);

// Update rows only when the `date` prop changes
useEffect(() => {
  // Create a date object from the string
  const convertedDate = new Date(date);

  // Get the current time (hours, minutes, seconds) from a new Date()
  const currentTime = new Date();

  // Set the time of convertedDate to the current time
  convertedDate.setHours(currentTime.getHours());
  convertedDate.setMinutes(currentTime.getMinutes());
  convertedDate.setSeconds(currentTime.getSeconds());

  console.log('Converted Date with Current Time:', convertedDate);

  // Update the rows state with the new date and time
  setRows([{ reqtime: convertedDate, type: 'IN' }]);
}, [date]); // Only runs when `date` changes

  // console.log('date',date)
  // console.log('newDate', new Date())

  const [totalMinutes, setTotalMinutes] = useState(0);
  const [totalHours, setTotalHours] = useState(0);

  // Helper function to format the time for the time input
  const formatTimeForInput = (date) => format(date, 'HH:mm');

  // Handle changes in the time input
  const handleTimeChange = (index, value) => {
    console.log('value',value)
    const updatedRows = [...rows];
    const [hours, minutes] = value.split(':');
    const updatedDate = new Date(updatedRows[index].reqtime);

    // Update the time part while keeping the date part the same
    updatedDate.setHours(hours);
    updatedDate.setMinutes(minutes);

    console.log('updatedDate',updatedDate)
    updatedRows[index].reqtime = updatedDate;
    setRows(updatedRows);
  };

  // Handle changes in the IN/OUT select
  const handleTypeChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].type = value;
    setRows(updatedRows);
  };

  // Add a new row
  const handleAddRow = () => {
    setRows([...rows, { reqtime: convertedDate, type: 'IN' }]);
  };

  // Delete a row
  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  // Calculate the total minutes and hours between IN and OUT rows
  const calculateTotalTime = () => {
    let totalMinutes = 0;
    for (let i = 0; i < rows.length - 1; i++) {
      if (rows[i].type === 'IN' && rows[i + 1].type === 'OUT') {
        totalMinutes += differenceInMinutes(rows[i + 1].reqtime, rows[i].reqtime);
      }
    }
    setTotalMinutes(totalMinutes);
    setTotalHours((totalMinutes / 60).toFixed(2)); // Round to 2 decimal places for hours
  };

  // Call calculateTotalTime whenever rows change
  React.useEffect(() => {
    if(rows.length > 0) {
      calculateTotalTime();
    }
  }, [rows]);

  // sendAPi
const sendAttendanceApi = async() => {
  try {
    const postDataToSend = JSON.stringify(postData);

    const response = await axios.post(`${base_url}/api/PersonalInfAttEvaluation`, postDataToSend, {
      headers: {
        'Content-Type': 'application/json', // Set the content type to application/json
      },
    });

    console.log('Response data:', response.data); // Log the response data
    if(response.status === 200) {
      toast.success('Attendance Updated successfully')
      setRows([])

      // fetchAttendanceDetail()
    }

  } catch (error) {
    console.error('Error sending attendance data:', error.response ? error.response.data : error.message); // Log any errors that occur
  }
}


// const fetchAttendanceDetail = async() => {
//   try {
//     const response = await axios.get(`${base_url}api/CRMAttendanceDetail/${cmpCode}/${popUpData.EmpId}/${date}`)

//     if(response.status === 200 && response.data) {
//       setAttendanceDetail(response.data)

//       console.log('settingAttDetailEffect')

//         // Call processPunches with the fetched data
//         // const processedPunches = processPunches(response.data);
//         // setPairedPunches(processedPunches); // Set the processed punches for rendering

//          // Calculate total time
//           const { totalMinutes, totalHours } = calculateTotalTime(response.data);
          
//           // Update the total minutes and hours in state
//           setTotalMinutes(totalMinutes);
//           setTotalHours(totalHours);
//           console.log(`Total Time: ${totalMinutes} minutes, ${totalHours} hours`);
//     }

//     else {
//       setError(true)
//     }


//   } catch (error) {
//     console.log('fetchAttendanceDetailError', error)
//       setError(true)

//   }
// }

  // Function to convert rows to desired format
const convertRowsToPostData = (rows, cmpCode, empId) => {
  return rows.map(row => {
      const punchTime = format(new Date(row.reqtime), 'yyyy-MMM-dd HH:mm'); // Format the date
      return {
          CmpCode: cmpCode,
          EmpId: empId,
          Type: row.type,
          PunchTime: punchTime,
          JobId: '-',
          Shift: '-'
      };
  });
};

  useEffect(() => {
    if(rows && popUpData) {
      const postData = convertRowsToPostData(rows, cmpCode, popUpData.EmpId);

      setPostData(postData)
    }
  },[rows,popUpData])

  console.log('rows',rows)
  console.log('postData',postData)

  return (
    <div>
      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1
                class="modal-title  text-secondary fs-small"
                id="staticBackdropLabel"
              >
                Attendance Entries
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Emp ID
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.EmpId}
                        disabled
                      />
                    </div>
                    {/* <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Emp Name
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.Name}
                        disabled
                      />
                    </div> */}

                    {/* <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Emp Name
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.JobTitle}
                        disabled
                      />
                    </div> */}

                    {/* <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Date
                      </label>
                      <input type="text" class="form-control" disabled />
                    </div> */}

                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Total Minutes
                      </label>
                      <input type="text" class="form-control" value={totalMinutes}/>
                    </div>
                    </div>


                  <div className="col-md-6">
                    {/* <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Time
                      </label>
                      <input type="text" class="form-control" disabled />
                    </div> */}

                  <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Emp Name
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        value={popUpData?.Name}
                        disabled
                      />
                    </div>

                    {/* <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Total Minutes
                      </label>
                      <input type="text" class="form-control" />
                    </div> */}

                    <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Total Hours
                      </label>
                      <input type="text" class="form-control" value={totalHours}/>
                    </div>

                    {/* <div class="mb-3">
                      <label
                        for="exampleInputEmail1"
                        class="form-label fs-small text-secondary"
                      >
                        Attendance Type
                      </label>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option selected>Attendance Type</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </select>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-body">
            <div class="scroll h-auto" style={{ maxHeight: '400px', overflow: 'auto' }}>
              <table className="table">
                <thead>
                  <tr>
                    <td>ReqTime</td>
                    <td>Type (IN/OUT)</td>
                    {/* <td>Actions</td> */}
                  </tr>
                </thead>
                <tbody>
                  {rows.length > 0 &&rows[0].reqtime !== null && rows.map((row, index) => (
                    <tr key={index}>
                      <td>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>{format(row.reqtime, 'dd-MMM-yyyy h:mm a')}</div>
                        <input
                          type="time"
                          className="form-control ms-3"
                          value={formatTimeForInput(row.reqtime)}
                          onChange={(e) => handleTimeChange(index, e.target.value)}
                          style={{ width: '180px' }} // Adjust width to fit within the row
                        />
                      </div>
                      </td>
                      <td>
                        <select
                          value={row.type}
                          onChange={(e) => handleTypeChange(index, e.target.value)} // Updated handler for type change
                        >
                          <option value="IN">IN</option>
                          <option value="OUT">OUT</option>
                        </select>
                      </td>
                      <td>
                        <button  class="btn red-btn" onClick={() => handleDeleteRow(index)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <button onClick={handleAddRow}>Add Row</button> */}

              {/* <div>Total Minutes: {calculateTotalMinutes()}</div> */}
            </div>
            </div>


            <div class="modal-footer">
              <button type="button" class="btn dash-btn" onClick={handleAddRow}>
                Add
              </button>
              <button type="button" class="btn dash-btn" onClick={() => sendAttendanceApi()}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendancePopup;
